<!--MobileFooter:页脚 2021/12/20 11:19:09 YuAng-->

<template>
  <div class="ho-mobile-footer">
    <div class="ho-footer-contact">
      <ul>
        <li v-for="(item,index) in contacts" :key="'li' + index">
          <p style="font-size: 14px">{{item.name}}</p>
          <p>{{item.info}}</p>
        </li>
      </ul>
      <div class="ho-contact-qrcode">
        <p style="font-size: 14px">关注我们</p>
        <p>
          <img alt="订阅号" src="../../../../assets/images/edition/ekt.jpg" width="60px" height="60px" />
        </p>
        <p>学科网e课堂订阅号</p>
        <p>
          <img alt="订阅号" src="../../../../assets/images/edition/ekt_video.jpg" width="60px" height="60px" />
        </p>
        <p>学科网e课堂视频号</p>
      </div>
    </div>
    <div class="ho-footer-other">
      <p>学科网（北京）股份有限公司</p>
      <p>网站备案号：京ICP备12013499号-24 </p>
      <p>北京市公安局海淀分局备案号：1101081948</p>
      <p>违法和不良信息举报电话：400-102-2000 举报邮箱：jubao@xkw.cn</p>
    </div>
  </div>
</template>
<script>
export default {
  name: 'MobileFooter',
  props: {
    item: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data() {
    return {
      contacts: [
        { name: '渠道合作', info: '手机：18101357219（微信同号）' },
        { name: '在线客服', info: '400-900-2556' },
        { name: '座机', info: '010-5834 9377' }
      ]
    }
  }
}
</script>

<style scoped>
.ho-mobile-footer {
    background: #F1F0F0;
}
.ho-footer-contact {
  overflow: hidden;
  padding: 16px 32px 8px 32px;
  line-height: 18px;
}

.ho-footer-contact ul {
  float: left;
}

.ho-footer-contact li {
  margin-bottom: 16px;
  font-size: 12px;
}

.ho-contact-qrcode {
  float: right;
  text-align: center;
  font-size: 12px;
}

.ho-footer-other {
  text-align: center;
  font-size: 12px;
  line-height: 18px;
  border-top: 1px solid rgba(153, 153, 153, 0.6);
  padding: 8px 0 16px 0;
}
</style>